<template>
    <div id='duplicate_reference_modal' class="modal">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Duplicate Reference: <strong>{{ searchReference }}</strong></p>
            </header>
            <section class="modal-card-body">
                <div style="margin-bottom:2em">
                    Quote reference numbers should be unique, but the following quotes were started with a reference
                    number ({{ searchReference }}) matching this quote:
                </div>
                <div class="content">
                    <table class="table is-striped" style="margin-bottom:4em">
                        <tbody>
                            <tr v-for="(ref, idx) in duplicate_reference" :key="'dup_ref_row' + idx">
                                <td>
                                    {{ ref.name }}
                                </td>
                                <td>
                                    {{ ref.time }}
                                </td>
                                <td style="position:relative">
                                    <div :ref="'tooltip_' + idx" class="box"
                                        style="position:absolute; right:100%; bottom:0; transform: translateY(50%); display:none;">
                                        <div v-for="(part, pidx) in ref.parts" :key="'dup_' + idx + '_part_' + pidx"
                                            style="width:100%; white-space:nowrap; z-index:9999">
                                            {{ part }}
                                        </div>
                                    </div>
                                    <a @mouseenter="(e) => { $refs['tooltip_' + idx][0].style.display = 'block' }"
                                        @mouseleave="(e) => { $refs['tooltip_' + idx][0].style.display = 'none' }"
                                        :data-tooltip="ref.parts">{{ ref.parts.length }} parts</a>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
            <footer class="modal-card-foot">
                <div style="width:100%;">
                    Continue to search with a duplicate reference?
                </div>
                <button class="button" @click="doSearch()">
                    Search
                </button>
                <button class="button is-danger" @click="doClose()">
                    Cancel
                </button>
            </footer>
        </div>
    </div>
</template>

<script>

export default {
    name: "DuplicateReferenceModal",
    props: {
        searchReference: {
            type: String,
            required: true,
        },
        duplicateReference: {
            type: Array,
            required: true,
        },
    },
    methods: {
        doClose() {
            this.$emit('doClose')
        },
        doSearch() {
            this.$emit('doClose')
        }
    }
};
</script>
